import { newRidgeState } from "react-ridge-state";
const dropDownComponentState = newRidgeState<any>(null);
export function useDropdownComponent() {
	const [dropdownComponent, setDropdownComponent] = dropDownComponentState.use();
	return {
		dropdownComponent,
		setDropdownComponent,
	};
}
 